import {Component, HostBinding} from '@angular/core';

@Component({
    selector: 'app-add-button',
    templateUrl: './add-button.component.html',
    standalone: false
})
export class AddButtonComponent {
    @HostBinding('class')
    classes = 'h-12 flex ';
}
